/* Venere Shop | Pagamento diretto Impulse 10: il carrello nativo resta sempre visibile. */
(function () {
  'use strict';
  if (window.venereCheckoutInitialized) return;
  window.venereCheckoutInitialized = true;

  function syncForm(form) {
    if (!form || !form.isConnected) return;
    const checkout = form.querySelector('[data-venere-checkout]');
    const native = form.querySelector('[data-add-to-cart]');
    const variant = form.querySelector('input[name="id"]');
    if (!checkout || checkout.dataset.venereBusy === 'true') return;
    const unavailable = !native || native.disabled || !variant || !variant.value;
    checkout.disabled = unavailable;
    checkout.setAttribute('aria-disabled', String(unavailable));
    const label = checkout.querySelector('[data-venere-checkout-label]');
    if (label) {
      const next = unavailable ? (native && native.textContent.trim() || 'NON DISPONIBILE') : 'VAI AL PAGAMENTO';
      if (label.textContent !== next) label.textContent = next;
    }
  }

  function initForm(form) {
    if (form.dataset.venereInitialized === 'true') return;
    form.dataset.venereInitialized = 'true';
    const observer = new MutationObserver(function (mutations) {
      if (mutations.some(function (m) {
        return m.type === 'childList' || (m.type === 'attributes' &&
          m.target.matches && m.target.matches('[data-add-to-cart], input[name="id"]'));
      })) syncForm(form);
    });
    observer.observe(form, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled','value']});
    syncForm(form);
  }

  function initForms() {document.querySelectorAll('form.venere-product-form').forEach(initForm);}

  document.addEventListener('click', async function (event) {
    const clicked = event.target;
    if (!clicked || typeof clicked.closest !== 'function') return;
    const button = clicked.closest('[data-venere-checkout]');
    if (!button) return;
    event.preventDefault();
    const form = button.closest('form.venere-product-form');
    if (!form || button.dataset.venereBusy === 'true') return;
    syncForm(form);
    const native = form.querySelector('[data-add-to-cart]');
    const variant = form.querySelector('input[name="id"]');
    const error = form.querySelector('[data-venere-checkout-error]');
    if (error) {error.hidden = true; error.textContent = '';}
    if (!variant || !variant.value || !native || native.disabled) {
      if (error) {error.textContent = 'Seleziona una variante disponibile prima di continuare.';error.hidden=false;}
      return;
    }
    // FormData(form) include i campi esterni con attributo form (quantita Impulse 10).
    const data = new FormData(form);
    const quantity = Number(data.get('quantity') || '1');
    if (!Number.isSafeInteger(quantity) || quantity < 1) {
      if (error) {error.textContent = 'Inserisci una quantità valida.';error.hidden=false;}
      return;
    }
    const label = button.querySelector('[data-venere-checkout-label]');
    button.dataset.venereBusy = 'true';
    button.disabled = true;
    if (label) label.textContent = 'ATTENDI...';
    try {
      const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const root = shopRoot.endsWith('/') ? shopRoot : shopRoot + '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',body:data,credentials:'same-origin',headers:{'Accept':'application/json'}
      });
      if (!response.ok) {
        let details = {};
        try { details = await response.json(); } catch (_) { /* unexpected response */ }
        throw new Error(details.description || details.message || 'Impossibile aggiungere il prodotto al carrello.');
      }
      window.location.assign('/checkout');
    } catch (err) {
      if (error) {error.textContent = (err && err.message) || 'Si è verificato un problema. Riprova.';error.hidden=false;}
      button.dataset.venereBusy = 'false';
      syncForm(form);
    }
  });
  document.addEventListener('change', function(event) {
    const section = event.target && event.target.closest && event.target.closest('.product-section');
    if (!section) return;
    const form = section.querySelector('form.venere-product-form');
    if (form) requestAnimationFrame(function(){syncForm(form);});
  });
  document.addEventListener('shopify:section:load', initForms);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initForms, {once:true});
  else initForms();
})();
